import { useEffect, useState } from "react";
import { showSnackbar } from "../Snackbar/snackbarManager";
import { violet600 } from "@/constants/colors";

const TIMER_DURATION = 30;
interface Props {
  resendOTP: () => Promise<void>;
}

const OTPResendTimer: React.FC<Props> = ({ resendOTP }) => {
  const [timeLeft, setTimeLeft] = useState(TIMER_DURATION);
  const [showTimer, setShowTimer] = useState(true);

  useEffect(() => {
    if (timeLeft === 0) {
      setShowTimer(false);
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const handleResendClick = () => {
    try {
      resendOTP();
      setTimeLeft(TIMER_DURATION);
      setShowTimer(true);
      showSnackbar("OTP sent successfully", { type: "success" });
    } catch (error) {
      console.error("Error sending OTP", error);
    }
  };

  return (
    <div>
      {showTimer ? (
        <p>0:{String(timeLeft).padStart(2, "0")}</p>
      ) : (
        <a
          onClick={handleResendClick}
          className="cursor-pointer hover:underline focus:underline"
          style={{ color: violet600 }}
        >
          Resend OTP
        </a>
      )}
    </div>
  );
};

export default OTPResendTimer;
